import {Badge} from '@dropbox/dig-components/badge';
import {Tooltip} from '@dropbox/dig-components/tooltips';
import {Text} from '@dropbox/dig-components/typography';
import {Box} from '@dropbox/dig-foundations';
import {t} from 'i18next';

import styles from './ReportCountBadge.module.css';

interface ReportCountBadgeProps {
  direct_report_count: number;
  total_report_count: number;
}

export const ReportCountBadge = ({
  direct_report_count,
  total_report_count,
}: ReportCountBadgeProps) => {
  return (
    <>
      <Tooltip
        title={
          <Box display="flex" flexDirection="column">
            <Text size="small">{t('direct_reports', {count: direct_report_count})}</Text>
            {total_report_count > direct_report_count ? (
              <Text size="small">{t('total_reports', {count: total_report_count})}</Text>
            ) : (
              ''
            )}
          </Box>
        }
      >
        <div className={styles.badge}>
          <Badge className={styles.container}>
            {direct_report_count}
            {total_report_count && total_report_count > direct_report_count ? '+' : ''}
          </Badge>
        </div>
      </Tooltip>
    </>
  );
};
